import { yup } from '@framework/validation/initYup.ts';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema.ts';
import { type IGraphicWidget } from '../IGraphicWidget.ts';

export const CommonGraphicWidgetConfigSchema: yup.ObjectSchema<IGraphicWidget> =
  CommonBaseWidgetSchema.shape({
    enabled: yup.mixed().notRequired().strip(),
  })
    .required()
    .noUnknown();
